import { BaseBeneficiaryMeta } from '/@/modules/estateaccount/models/meta/BaseBeneficiaryMeta';
import { EstateRelationshipType } from '/@/modules/estate/enums/EstateRelationshipType';

export class BeneficiaryOrganizationMeta extends BaseBeneficiaryMeta {
  /**
   * @var {string}
   */
  organizationName;

  /**
   * @var {string}
   */
  registrationNumber;

  /**
   * @var {string}
   */
  relationshipType;

  /**
   * @var {string}
   */
  otherRelationshipType;

  constructor(model = {}) {
    super(model);

    this.organizationName = model.organizationName;
    this.registrationNumber = model.registrationNumber;
    this.relationshipType = model.relationshipType ?? EstateRelationshipType.OTHER.key;
    this.otherRelationshipType = model.otherRelationshipType;
  }
}
